module.exports = __webpack_public_path__ + "img/imgSrc1.05936c3d.png";